import { requestHandler } from 'lib/api';
import { DocumentConciliationRateHistory } from 'lib/common/GeneralComponents/DocumentProfile/components/types';
import { Dispatch } from 'redux';

import {
  BalanceReportItem,
  PlacementsReportResponse,
  SurplusesReportResponse,
} from './types';

export const getActiveMoneyReports = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/activeMoney?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};
export const getPlacementsChartReport = async (
  dispatch: Dispatch,
  queryParams: string,
): Promise<PlacementsReportResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/activeHistoryFactoring?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getTransactBookReport = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/transactBook?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getFullTransactBookReport = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/fullTransactBook?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getIncomeBookReport = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/incomeBook?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSimpleIncomeBookReport = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/simpleIncomeBook?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getInvoicingBookReport = async (
  dispatch: Dispatch,
  startDate: string,
  endDate: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/report/invoicingBook`,
    data: { startDate, endDate },
    dispatch,
  });
  if (response) return response.data;
};

export const getCollectionReport = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/collection?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAccruingReport = async (dispatch: Dispatch, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/accruing?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSurplusesReport = async (
  dispatch: Dispatch,
  query: string,
): Promise<SurplusesReportResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/surpluses?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentConciliationRateHistory = async (
  dispatch: Dispatch,
  documentId: string,
): Promise<DocumentConciliationRateHistory | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/document/${documentId}/conciliationRateHistory`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBalancesReport = async (
  dispatch: Dispatch,
): Promise<BalanceReportItem[] | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/balances`,
    dispatch,
  });
  if (response) return response.data;
};

export const getEFAReport = async (
  dispatch: Dispatch,
): Promise<{ fileContent: string; fileName: string } | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/balances/efa`,
    dispatch,
  });
  if (response) return response.data;
};
